import { setAirportsFieldValue, setDestinationFieldValue, setTravellersFieldMultiroomValue, setTravellersFieldValue, setTravelPeriodFieldValue, setTravelType } from '../../../components/SearchForm/redux/actions.js';
import * as reducerExports from '../../../components/SearchForm/redux/reducer.js';
const {
  searchFormReducer,
  ...searchFormSelectors
} = reducerExports;
export { searchFormReducer, searchFormSelectors };
export const searchFormActions = {
  setTravelType,
  setDestinationFieldValue,
  setAirportsFieldValue,
  setTravellersFieldValue,
  setTravellersFieldMultiroomValue,
  setTravelPeriodFieldValue
};
export { searchFormState } from '../../../components/SearchForm/redux/SearchFormState.js';
export { trackingEvents as searchFormTrackingEventsMap } from '../../../components/SearchForm/redux/trackingEvents.js';
export { searchFormScopedAction } from '../../../components/SearchForm/redux/utils.js';